import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import { useCallback, useState } from 'react'

import { i18WithDefault as t } from '@shared/locales'

type TButtonActionsProps = {
  actionEnabled?: boolean
  actionLabel?: string
  actionVariant?: 'primary' | 'secondary'
  size?: 'small' | 'medium'
  onAction: () => Promise<void | unknown>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCancel?: (...args: any[]) => Promise<void | unknown>
  onCancelLabel?: string
  onActionLabel?: string
  invertButtons?: boolean
}

export const ButtonActions = ({
  actionEnabled = true,
  onAction,
  onCancel,
  onCancelLabel,
  onActionLabel,
  actionVariant = 'primary',
  size = 'medium',
  invertButtons = false,
}: TButtonActionsProps) => {
  const [executingAction, setExecutingAction] = useState<boolean>(false)
  const [executingCancel, setExecutingCancel] = useState<boolean>(false)

  const localAction = useCallback(async () => {
    try {
      setExecutingAction(true)
      await onAction()
    } finally {
      setExecutingAction(false)
    }
  }, [onAction])
  const localCancel = useCallback(async () => {
    if (!onCancel) {
      return
    }

    try {
      setExecutingCancel(true)
      await onCancel()
    } finally {
      setExecutingCancel(false)
    }
  }, [onCancel])

  const buttons = [
    onCancel ? (
      <LoadingButton
        key="btn-cancel"
        variant="text"
        disabled={executingCancel}
        loading={executingCancel}
        onClick={localCancel}
      >
        {onCancelLabel || t('global.label.cancel')}
      </LoadingButton>
    ) : null,
    <LoadingButton
      key="btn-action"
      type="submit"
      variant="contained"
      color={actionVariant}
      disabled={!actionEnabled}
      loading={executingAction}
      onClick={localAction}
    >
      {onActionLabel || t('global.label.save')}
    </LoadingButton>,
  ]

  if (invertButtons) {
    buttons.reverse()
  }

  return (
    <Stack direction="row" spacing={size === 'small' ? 1 : 2}>
      {buttons}
    </Stack>
  )
}
